<template>
  <div>
    <!-- {{ model }} -->
    <b-table-simple hover small caption-top responsive style="max-width: 600px">
      <b-thead>
        <b-tr>
          <b-th v-for="field in header" :key="field.label">
            {{ field.label }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td>
            <label for="isMandatoryDescription">DETALHAMENTO DA O.S</label>
          </b-td>
          <b-td>
            <b-form-checkbox
              id="isMandatoryDescription"
              v-model="model.isMandatoryDescription"
            >
            </b-form-checkbox>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>
            <label for="isMandatoryPartsValue">VALOR DAS PEÇAS</label>
          </b-td>
          <b-td>
            <b-form-checkbox
              id="isMandatoryPartsValue"
              v-model="model.isMandatoryPartsValue"
            >
              <span v-if="!hasValue()" class="text-warning">
                Um valor deve ser Obrigatório</span
              >
            </b-form-checkbox>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>
            <label for="isMandatoryLaborValue">VALOR DA MÃO DE OBRA</label>
          </b-td>
          <b-td>
            <b-form-checkbox
              id="isMandatoryLaborValue"
              v-model="model.isMandatoryLaborValue"
            >
              <span v-if="!hasValue()" class="text-warning">
                Um valor deve ser Obrigatório</span
              >
            </b-form-checkbox>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>
            <label for="isMandatoryTotalValue">VALOR TOTAL</label>
          </b-td>
          <b-td>
            <b-form-checkbox
              id="isMandatoryTotalValue"
              v-model="model.isMandatoryTotalValue"
            >
              <span v-if="!hasValue()" class="text-warning">
                Um valor deve ser Obrigatório</span
              >
            </b-form-checkbox>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>
            <label for="isMandatoryNotePhoto">NOTA FISCAL</label>
          </b-td>
          <b-td>
            <b-form-checkbox
              id="isMandatoryNotePhoto"
              v-model="model.isMandatoryNotePhoto"
            >
            </b-form-checkbox>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>
            <label for="isMandatoryExitPhoto">FOTO DE SAÍDA</label>
          </b-td>
          <b-td>
            <b-form-checkbox
              id="isMandatoryExitPhoto"
              v-model="model.isMandatoryExitPhoto"
            >
            </b-form-checkbox>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: "RevisionExitConfigurationCrud",
  props: {
    model: Object,
    submitted: Boolean,
  },
  data() {
    return {
      header: [
        {
          label: "Nome",
        },
        {
          label: "Obrigatório",
        },
      ],
    };
  },
  computed: {},
  methods: {
    hasValue() {
      if (
        this.model.isMandatoryPartsValue ||
        this.model.isMandatoryLaborValue ||
        this.model.isMandatoryTotalValue
      ) {
        this.$emit("update:submitted", false);
        return true;
      }
      this.$emit("update:submitted", true);
      return false;
    },
  },
  mounted() {
    // Code to run when the component is mounted
  },
};
</script>

<style scoped>
/* Your styles here */
</style>